import { RootState } from 'redux/reducers/rootReducer';

const myApprovedClientsSelector = (state: RootState) =>
  state.client.approvedClients;
const clientCreatedAtSelector = (state: RootState) =>
  state.client.clientCreatedAt;
const clientDraftCreatedAtSelector = (state: RootState) =>
  state.client.clientDraftCreatedAt;
const clientDetailsSelector = (state: RootState) => state.client.clientDetails;
const isClientModalOpenSelector = (state: RootState) =>
  state.client.isClientModalOpen;
const customerDetailsUpdatedAtByAdminSelector = (state: RootState) =>
  state.client.customerDetailsUpdatedAtByAdmin;

export {
  clientCreatedAtSelector,
  myApprovedClientsSelector,
  clientDraftCreatedAtSelector,
  clientDetailsSelector,
  isClientModalOpenSelector,
  customerDetailsUpdatedAtByAdminSelector,
};
